/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type MappingCellReference = {
  /**
   * The cell, e.g. C4.
   */
  ref: string;
  direction?: MappingCellReference.direction;
};
export namespace MappingCellReference {
  export enum direction {
    POSITIVE = 'positive',
    NEGATIVE = 'negative',
  }
}

